// Utility function to focus the top-most focusable element on the page
export const FocusOnTop = () => {
    // Define selectors for common focusable elements
    const focusableSelectors = [
        'a',
        'button:not([disabled])',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        '[tabindex]:not([tabindex="-1"])'
    ].join(', ');

    // Get all matching elements
    const focusableElements = Array.from(document.querySelectorAll(focusableSelectors))
        .filter(el => {
            // Filter out elements that are hidden or not visible
            const style = window.getComputedStyle(el);
            return style.display !== 'none' && style.visibility !== 'hidden';
        });

    // Sort elements by their distance from the top of the viewport
    const sortedElements = focusableElements.sort((a, b) => {
        return a.getBoundingClientRect().top - b.getBoundingClientRect().top;
    });

    // Focus the top-most element if one exists and then blur immediately
    if (sortedElements.length > 0) {
        sortedElements[0].focus();
        sortedElements[0].blur();
    }
}

export default FocusOnTop;